import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { requestErrorHandler } from "utils";
import { ListPickingFilesActions } from "store/ducks/picking-files";

export function* listPickingFilesRequest(action: any) {
  try {
    const { query: id, onSuccess } = action;
    const { data } = yield call(api.get, `/picking-files/${id}`);

    yield put(ListPickingFilesActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListPickingFilesActions.failure(errorMessage));
  }
}
